import { useGeneralEnterprisesByIds } from '../../enterpriseRelationships/queries';
import { useGetPropertiesGroups } from '../queries/CentralProductsTable';

export const useNamesFromIds = (propertyIds: string[], propertyGroupIds: string[]) => {
    const { data: enterprisesData } = useGeneralEnterprisesByIds(propertyIds);
    const { data: propertiesGroupsData } = useGetPropertiesGroups(propertyGroupIds);
    /** lookupTable for properties and propertyGroups are to create simple key:value object
     * where key is propertyId/propertyGroupId and value is name. This is later used to
     * simply match id from object and find the name accordingly.
     */
    const propertiesLookupTable = enterprisesData?.enterprises.reduce<Record<string, string>>((acc, property) => {
        acc[property.id] = property.name;
        return acc;
    }, {});

    const propertyGroupsLookupTable = propertiesGroupsData?.data.reduce<Record<string, string>>(
        (acc, propertyGroup) => {
            acc[propertyGroup.id] = propertyGroup.name;
            return acc;
        },
        {}
    );

    return { propertiesLookupTable, propertyGroupsLookupTable };
};
